document.getElementById("submit").addEventListener("click", calcFinance());

let searchParams = new URLSearchParams(window.location.search);
if(searchParams.has('price')){
  var price = searchParams.get('price');
  document.getElementById("cashPrice").value = ((price / 100).toFixed(2));
}

function calcFinance(){
  
  var value = document.getElementById("cashPrice").value;
  var serviceBool = document.getElementById("servicePackage").value;
  var monthlyOutput = document.getElementById("monthly");
  var weeklyOutput = document.getElementById("weekly");
  var dailyOutput = document.getElementById("daily");

  var monthlyOutputVal = 0;
  var weeklyOutputVal = 0;
  var dailyOutputVal = 0;
  var service = 0;

  var termLength = document.getElementById("termLength").value;
  var companyType = document.getElementById("companyType").value;

  if(serviceBool == "yes"){
    service = (495 * termLength);
  }

  if(companyType == "established"){
    if(termLength == 2){
      monthlyOutputVal = (value * 0.0492) + (service / 12);
    } else if(termLength == 3){
      monthlyOutputVal = (value * 0.03432) + (service / 12);
    } else if(termLength == 4){
      monthlyOutputVal = (value * 0.02647) + (service / 12);
    } else if(termLength == 5){
      monthlyOutputVal = (value * 0.0225) + (service / 12);
    }
  } else if (companyType == "newStart"){
    if(termLength == 2){
      monthlyOutputVal = (value * 0.05265) + (service / 12);
    } else if(termLength == 3){
      monthlyOutputVal = (value * 0.03797) + (service / 12);
    } else if(termLength == 4){
      monthlyOutputVal = (value * 0.03073) + (service / 12);
    } else if(termLength == 5){
      monthlyOutputVal = (value * 0.02647) + (service / 12);
    }
  } else {
    alert("no company?");
  }
  weeklyOutputVal = (monthlyOutputVal * 12) / 52;
  dailyOutputVal = weeklyOutputVal / 7;

  /*outputs*/

  monthlyOutput.innerHTML = "£" + monthlyOutputVal.toFixed(2);
  weeklyOutput.innerHTML = "£" + weeklyOutputVal.toFixed(2);
  dailyOutput.innerHTML = "£" + dailyOutputVal.toFixed(2);
}